module.exports = __webpack_public_path__ + "img/skip-back.bdc97087.svg";